import React from 'react';
import { customTypes, formats, useFlags } from 'utils';
import { Typography, Link, Spinner } from 'components/alf-design';

import MortgageePaid from './MortgageePaid';
import InsuredPaid from './InsuredPaid';

const BillingContent = ({ billing, agent, loading, ...insuredProps }) => {
  const { showCancellationData, disableMakePayments } = useFlags();

  if (loading) {
    return (
      <div className="flex justify-center items-center">
        {loading && <Spinner id="dashboard-spinner" size={80} />}
      </div>
    );
  }

  if (billing?.Errors?.length > 0 && billing?.Errors[0]?.statusCode === '500') {
    return (
      <div className="bg-legacy-errorBackground border border-legacy-errorBorder p-[13px] rounded-[8px]">
        <Typography type="error">
          Billing information is not currently available. Please try again
          later.
        </Typography>
      </div>
    );
  }

  if (!billing || billing.error) {
    const errorMessage = billing
      ? billing.error
      : 'There was an error fetching your billing information. Please try again later.';

    return (
      <div className="bg-legacy-errorBackground border border-legacy-errorBorder p-[13px] rounded-[8px]">
        <Typography type="error">{errorMessage}</Typography>
        <Typography type="error">
          For immediate assistance, please contact your agent.
        </Typography>
        {agent.organizationName && (
          <Typography type="error" component="p" style={{ marginTop: 26 }}>
            <b>{agent.organizationName}</b>
          </Typography>
        )}
        {agent.phone && (
          <Link
            type="primary"
            href={`tel:${agent.phone}`}
            className="text-legacy-primary"
          >
            {formats.phoneFormat(agent.phone)}
          </Link>
        )}
      </div>
    );
  }

  return (
    <>
      {billing.isMortgagee ? (
        <MortgageePaid
          billing={billing}
          showCancellationData={showCancellationData}
        />
      ) : (
        <InsuredPaid
          billing={billing}
          showCancellationData={showCancellationData}
          disableMakePayments={disableMakePayments}
          {...insuredProps}
        />
      )}
    </>
  );
};

BillingContent.propTypes = {
  billing: customTypes.billing,
  agent: customTypes.agent,
};

export default BillingContent;
